var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.953613H513V342.954H0V0.953613Z",
    fill: "#3D944F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.953613H513V171.954H0V0.953613Z",
    fill: "#EF2B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 103.554L272.9 155.554H327.6L283.4 187.754L300.2 239.754L256 207.654L211.8 239.754L228.6 187.754L184.4 155.554H239.1L256 103.554Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.953613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBf);
export default __webpack_public_path__ + "static/media/BF.68750cf64e7602124aece693d9e8420f.svg";
export { ForwardRef as ReactComponent };